import { Component } from '@angular/core';
import { SessionService } from '../../../shared/services/Session.service';

@Component({
  selector: 'rolePage',
  templateUrl: './rolePage.component.html',
  styleUrls: ['./rolePage.component.css']
})
export class RolePageComponent {

  constructor(private sessionService: SessionService) { }

  ngOnInit(): void {
    this.sessionService.setIsExternalMap(false);
  }

}
